import { z } from 'zod';
import { c } from '../../contract';
import { paywallSocialProofResponse } from '../../utils/paywallSocialProof';

export const socialProofRouter = c.router({
  getSocialProofStatistics: {
    summary: 'Retrieves the social proof statistics for a given series',
    method: 'GET',
    path: '/social-proof',
    query: z.object({
      seriesId: z.string(),
    }),
    responses: {
      200: z.object({
        createdAt: z.date(),
        updatedAt: z.date(),
        seriesId: z.string(),
        chaptersRead: z.number(),
        comments: z.number(),
        bookmarksSaved: z.number(),
        shares: z.number(),
        storyStarts: z.number(),
      }),
      404: z.string(),
    },
  },
  getManySocialProofStatistics: {
    summary: 'Retrieves the social proof statistics for a list of series',
    method: 'POST',
    path: '/social-proof',
    body: z.object({
      seriesIds: z.array(z.string()),
    }),
    responses: {
      200: z.array(
        z.object({
          createdAt: z.date(),
          updatedAt: z.date(),
          seriesId: z.string(),
          chaptersRead: z.number(),
          comments: z.number(),
          bookmarksSaved: z.number(),
          shares: z.number(),
          storyStarts: z.number(),
        }),
      ),
    },
  },
  getPaywallSocialProof: {
    summary: 'Retrieves the reader counts shown as social proof on the paywall',
    method: 'GET',
    path: '/social-proof/paywall',
    query: z.object({
      countryCode: z.string().length(2).optional(),
    }),
    responses: {
      200: paywallSocialProofResponse,
      503: z.string(),
    },
  },
  updateSocialProofStatistics: {
    summary: 'Trigger an update of social proof statistics for a given series',
    method: 'POST',
    path: '/social-proof/update',
    body: z.object({}).optional(),
    responses: {
      200: z.object({
        success: z.boolean(),
      }),
    },
  },
});
